<template>
	<div class="pb-21 md:pb-21">
		<div class="grid grid-cols-12">
            <div class="col-span-12 mt-21 max-md:pt-1 md:mt-24 mb-10 md:mb-21">
    			<h1 class="headline-big">Arkiv<span class="font-serif">/</span> <span class="text-gray-dark">Archive</span></h1>
            </div>
        </div>

        <div class="grid grid-cols-12" v-if="archive">
            <div class="col-span-12 md:col-span-2">
                <div class="sticky top-22">
                    <h3 class="text-mini uppercase mb-4">Filtrer <span class="font-serif">/</span> <span class="text-gray-dark">Filter by</span></h3>

                    <div class="max-md:flex max-md:flex-wrap">
                        <div class="max-md:w-1/2 md:mb-8">
                            <p class="text-mini uppercase mb-4">Scener</p>

                            <ul class="mb-8 last:mb-0">
                                <li class="mb-2">
                                    <label class="flex flex-row items-center cursor-pointer">
                                        <input type="radio" value="all" :checked="stage == 'all'" @change="setStage('all')" name="stage">
                                        <p class="input-label">Vis alle</p>
                                    </label>
                                </li>
                                <li class="mb-2" v-for="(stageEntry, index) in archive.stages" :key="index">
                                    <label class="flex flex-row items-center cursor-pointer">
                                        <input type="radio" :value="stageEntry.slug" :checked="stage == stageEntry.slug" @change="setStage(stageEntry.slug)" name="stage">
                                        <p class="input-label">{{stageEntry.title}}</p>
                                    </label>
                                </li>
                            </ul>
                        </div>
                        <div class="max-md:w-1/2">
                            <p class="text-mini uppercase mb-4">Kategori</p>

                            <ul class="mb-8 last:mb-0">
                                <li class="mb-2">
                                    <label class="flex flex-row items-center">
                                        <input type="radio" value="all" :checked="category == 'all'" @change="setCategory('all')" name="category">
                                        <p class="input-label">Vis alle</p>
                                    </label>
                                </li>
                                <li class="mb-2" v-for="(categoryEntry, index) in archive.categories" :key="index">
                                    <label class="flex flex-row items-center">
                                        <input type="radio" :value="categoryEntry.slug" :checked="category == categoryEntry.slug" @change="setCategory(categoryEntry.slug)" name="category">
                                        <p class="input-label">{{categoryEntry.title}}</p>
                                    </label>
                                </li>
                                <li class="mb-2">
                                    <label class="flex flex-row items-center">
                                        <input type="radio" value="news" :checked="category == 'news'" @change="setCategory('news')" name="category">
                                        <p class="input-label">Nyheder</p>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-12 md:col-span-10">
                <div v-for="(entry, index) in archiveEntries.slice(0, showEntries)" :key="index" class="first:-mt-4">

                    <div v-if="entry.__typename === 'event_Entry'">
                        <ElementAccordion :hideArrowOnMobile="true">
                            <template v-slot:header>
                                <div class="max-md:grid-cols-12 max-md:gap-y-2 grid-cols-10 grid">
                                    <div class="max-md:order-3 max-md:col-span-8 col-span-3">
                                        <h2 class="text-sm uppercase">{{entry.title}}</h2>
                                    </div>
                                    <div class="max-md:order-4 max-md:text-right max-md:col-span-4 col-span-3">
                                        <p class="headline-serif md:text-sm-serif">{{$dateFormat(entry.dateFrom, entry.dateTo)}}</p>
                                    </div>
                                    <div class="max-md:order-2 max-md:text-right max-md:col-span-6 col-span-2">
                                        <p class="text-mini uppercase" v-if="entry.category">{{entry.category[0].title}}</p>
                                    </div>
                                    <div class="max-md:order-1 max-md:col-span-6 col-span-2">
                                        <p class="text-mini uppercase" v-if="entry.stage">{{entry.stage[0].title}}</p>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div class="max-md:block grid-cols-10 grid">
                                    <div class="md:col-span-3 max-md:mb-4 ">
                                        <NuxtLink :to="`/event/${entry.slug}`">
                                            <div class="aspect-card">
                                                <Media :data="entry.media[0]" />
                                            </div>
                                        </NuxtLink>
                                    </div>
                                    <div class="col-span-4 text-base-serif">
                                        <div v-html="entry.text"></div>
                                        <div v-html="entry.textEnglish" class="text-gray-dark mt-4"></div>
                                    </div>
                                    <div class="col-span-2 col-start-9 max-md:mt-8">
                                        <NuxtLink :to="`/event/${entry.slug}`">
                                            <ElementButton :styleClasses="'md:text-mini'" :title="'Læs mere'" :englishTitle="'Read more'"/>
                                        </NuxtLink>
                                    </div>
                                </div>
                            </template>
                        </ElementAccordion>
                    </div>

                    <div v-if="entry.__typename === 'post_Entry'">
                        <ElementAccordion :hideArrowOnMobile="true">
                            <template v-slot:header>
                                <div class="max-md:grid-cols-12 max-md:gap-y-2 grid-cols-10 grid">
                                    <div class="max-md:order-3 max-md:col-span-8 col-span-3">
                                        <h2 class="text-sm uppercase">{{entry.title}}</h2>
                                    </div>
                                    <div class="max-md:order-4 max-md:text-right max-md:col-span-4 col-span-3">
                                        <p class="headline-serif md:text-sm-serif">{{$dateFormat(entry.postDate)}}</p>
                                    </div>
                                    <div class="max-md:order-2 max-md:text-right max-md:col-span-6 col-span-2">
                                        <p class="text-mini uppercase" v-if="entry.authorName">{{entry.authorName}}</p>
                                    </div>
                                    <div class="max-md:order-1 max-md:col-span-6 col-span-2">
                                        <p class="text-mini uppercase">Nyhed</p>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:content>
                                <div class="max-md:block grid-cols-10 grid">
                                    <div class="max-md:mb-4 col-span-3">
                                        <NuxtLink :to="`/news/${entry.slug}`">
                                            <div class="aspect-card">
                                                <Media :data="entry.media[0]" class="block aspect-card" v-if="entry.media[0]"/>
                                                <div v-if="!entry.media[0]" class="bg-green aspect-card w-full"></div>
                                            </div>
                                        </NuxtLink>
                                    </div>
                                    <div class="col-span-4 text-base-serif">
                                        <div v-html="entry.excerpt"></div>
                                    </div>
                                    <div class="col-span-2 col-start-9 max-md:mt-8">
                                        <NuxtLink :to="`/news/${entry.slug}`">
                                            <ElementButton :styleClasses="'md:text-mini'" :title="'Læs mere'" :englishTitle="'Read more'"/>
                                        </NuxtLink>
                                    </div>
                                </div>
                            </template>
                        </ElementAccordion>
                    </div>

                </div>

                <button @click="showEntries += 20" class="mt-14" v-if="showEntries <= archiveEntries.length  - 1">
                    <ElementButton :title="'Udvid arkiv'" :englishTitle="'Extend archive'"/>
                </button>
            </div>
        </div>
	</div>
</template>

<script setup>
const { $dateFormat } = useNuxtApp()
import { archiveQuery } from '@/api/queries'
import { onMounted } from 'vue';
const config = useRuntimeConfig();
const route = useRoute();
const router = useRouter();

const showEntries = ref(20)

const sortedEntries = ref(null)
const archive = ref(null)
const archiveEntries = ref(null)

const category = ref(route.query.category ? route.query.category : 'all')
const stage = ref(route.query.stage ? route.query.stage : 'all')

const setCategory = (categoryVal) => {
    category.value = categoryVal
}

const setStage = (stageVal) => {
    stage.value = stageVal
}

const setQuery = () => {
    const newQuery = {}

    if (category.value !== 'all') {
        newQuery.category = category.value
    }

    if (stage.value !== 'all') {
        newQuery.stage = stage.value
    }

    router.push({
        query: newQuery
    })

    // archiveEntries.value = filterEntries(entries)
    if (archiveEntries.value) {
        archiveEntries.value = filterEntries(sortedEntries.value)
    }
}

watch(() => category, () => {
    setQuery()
}, { immediate: true, deep: true })

watch(() => stage, () => {
    setQuery()
}, { immediate: true, deep: true })

const filterEntries = (entries) => {
    return entries.filter(entry => {
        if (entry.__typename == "event_Entry") {
            return (stage.value === 'all' || entry.stage.some(stageEntry => stageEntry.slug === stage.value)) && (category.value === 'all' || entry.category.some(categoryEntry => categoryEntry.slug === category.value));
        }

        if (entry.__typename == "post_Entry") {
            return (category.value === 'news' || category.value == 'all') && stage.value === 'all';
        }

        return true
    })
}

// Build the URL, with `query` and `token` params:
const query = archiveQuery()
const token = route.query.token;

const getData = async () => {
    const { data: gql } = await useFetch(config.public.API, {
        params: { query, token },
    });

    // Extract the first page from the response:
    if (gql.value) {
        archive.value = gql.value.data;
        const combinedEntries = [...archive.value.news, ...archive.value.events]

        sortedEntries.value = combinedEntries.sort((a, b) => {
            const dateA = new Date(a.sortDate);
            const dateB = new Date(b.sortDate);
            return dateB - dateA;
        });

        archiveEntries.value = filterEntries(sortedEntries.value)
    }
}

await getData();

onMounted(() => {
    if (!archive.value) {
        getData();
    }
})

useHead({
	title: 'Sydhavn Teater — Arkiv / Archive',
	meta: [
		{ hid: 'og:title', property: 'og:title', content: 'Sydhavn Teater — Arkiv / Archive' },
	],
});
</script>

<style lang="scss" scoped>
:deep(.arrow-button) {
    svg {
        width: 1.5rem;;
    }
}

.aspect-card :deep(.media) {
    @apply w-full h-full;

    img {
        @apply w-full h-full object-cover;
    }
}
</style>